const baseRoute =
  'comsa-reports/:moduleBridgeHex/:subModuleBridgeHex/:plantHex/';
export const routes = {
  // user_module_comsaReports_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //     subModuleBridgeHex: undefined,
  //     plantHex: undefined,
  //   },
  // },
  user_module_comsaReports_home: {
    path: `${baseRoute}home`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_power_use: {
    path: `${baseRoute}power-use`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_fuel_use: {
    path: `${baseRoute}fuel-use`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_water_use: {
    path: `${baseRoute}water-use`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_paper_use: {
    path: `${baseRoute}paper-use`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_natural_gas_use: {
    path: `${baseRoute}natural-gas-use`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_cooling_gas_use: {
    path: `${baseRoute}cooling-gas-use`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_water_waste: {
    path: `${baseRoute}water-waste`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_waste_management: {
    path: `${baseRoute}waste-management`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_natural_resources_use_reduction: {
    path: `${baseRoute}natural-resources-use-reduction`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_landscape_restoration: {
    path: `${baseRoute}landscape-restoration`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  //
  user_module_comsaReports_energy_efficiency: {
    path: `${baseRoute}energy-efficiency`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_waste_recovery: {
    path: `${baseRoute}waste-recovery`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_carbon_footprint: {
    path: `${baseRoute}carbon-footprint`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_recycled_packaging_material: {
    path: `${baseRoute}recycled-packaging-material`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_tertiary_packaging: {
    path: `${baseRoute}tertiary-packaging`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_food_waste: {
    path: `${baseRoute}food-waste`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_energy_certificate: {
    path: `${baseRoute}energy-certificate`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_electric_charger: {
    path: `${baseRoute}electric-charger`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_goodLogisticsPractices: {
    path: `${baseRoute}good-logistics-practices`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_occupation: {
    path: `${baseRoute}occupation`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_recycledPaper: {
    path: `${baseRoute}recycled-paper`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_nonRecycledPaper: {
    path: `${baseRoute}non-recycled-paper`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaReports_biodiversity: {
    path: `${baseRoute}biodiversity`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  // user_module_comsaReports_get_xls_report: {
  //     path: `${baseRoute}get-xls-report`,
  //     parameters: {
  //         moduleBridgeHex: undefined,
  //         subModuleBridgeHex: undefined,
  //         plantHex: undefined,
  //     }
  // },
};
